import { DocumentNode } from 'graphql';
import { useQuery } from 'react-apollo';

export const getQueryData = (
  query: DocumentNode,
  companyId: string,
  dates?: { startDate: string; endDate: string },
) => {
  return useQuery(query, {
    variables: dates
      ? {
          companyId,
          startDate: dates.startDate,
          endDate: dates.endDate,
        }
      : {
          companyId,
        },
    fetchPolicy: 'network-only',
  });
};
